import { PER_PAGE } from 'app/constants';

import { get, patch } from './http-methods';

export default {
  async getList({ page, sort_field, sort_order, status }) {
    try {
      const offset = PER_PAGE * (page - 1);
      const statusParam = status ? `&status=${status}` : '';
      const { json } = await get(`/qrdiag?offset=${offset}&page_size=${PER_PAGE}&sort_field=${sort_field}&sort_order=${sort_order}${statusParam}`);

      return json;
    } catch (error) {
      console.error('[ERROR]:', error);
    }
  },
  async getItem(id) {
    try {
      const { json } = await get(`/qrdiag/${id}`);

      return json;
    } catch (error) {
      console.error('[ERROR]:', error);
    }
  },
  async getLogsById(id) {
    try {
      const { text } = await get(`/qrdiag/${id}/logs`);

      return text;
    } catch (error) {
      console.error('[ERROR]:', error);
    }
  },
  async downloadXMLFileById(id) {
    try {
      const { xml, headers } = await get(`/qrdiag/${id}/bde/xml`);
      const [_, filename] = headers.get('content-disposition').replace(/"/g, '').split('filename=');
      
      return { xml, filename };
    } catch (error) {
      console.error('[ERROR]:', error);
    }
  },
  async updateQrReportStatusById(id, status) {
    try {
      const response = await patch(`/qrdiag/${id}/status/${status}`);
      return response;
    } catch (error) {
      console.error('[updateQrReportStatusById][error]:', error);
    }
  },
};
